import AbstractConfig from "../../config/AbstractConfig";

/**
 * Provides the configuration for the fonts.
 * 
 * Note: the font entries for the  groups should be specified in [FVD format](https://github.com/typekit/webfontloader)
 * in order to specify the style and weight necessary to load from the font family.
 */
export default class FontsConfig extends AbstractConfig {
    constructor() {
        super();
        /** @type {Object.<string, string[]>}} */
        this._fontGroups = {};
    }

    /**
     * Gets the array of font family strings in [FVD format](https://github.com/typekit/webfontloader)
     * @param {...string} groups 
     * @returns {string[]} Font array in [FVD format](https://github.com/typekit/fvd)
     */
    getFontsFromGroups(...groups) {
        const fonts = groups.flatMap(p => this._fontGroups[p]);
        return fonts;
    }

    setPropertiesFromObject(obj) {
        super.setPropertiesFromObject(obj);
        // prepare loading fonts
        this._fontGroups = this.getValue('fontGroups');
    }
}